import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ProjectType } from 'blocks/ProjectsPage/types';
import { isWorkflowLimitReachedSelector } from 'redux/modules/automation-cms/selectors';
import {
  onClickAutomationTile,
  onClickTranscribe,
  onCreateManualAudiogram,
} from 'redux/modules/mixpanel';
import { pushModal } from 'redux/modules/modal';

export interface UseNewProjectClickResult {
  onNewProjectClick: (
    type: ProjectType,
    _: any,
    e: React.MouseEvent<any>,
  ) => void;
}

export default function useNewProjectClick(): UseNewProjectClickResult {
  const dispatch = useDispatch();

  const handleNewProjectClick = useCallback(
    (type: ProjectType, _, e: React.MouseEvent<any>): void => {
      if (type === 'blank') {
        e.preventDefault();

        dispatch(
          pushModal({
            name: 'BlankProject',
          }),
        );
      }

      const isWorkflowLimitReached = dispatch((__, getState) =>
        isWorkflowLimitReachedSelector(getState()),
      );

      if (type === 'autovideo' && isWorkflowLimitReached) {
        e.preventDefault();

        dispatch(
          pushModal({
            name: 'AddAutomationUpgrade',
            params: { podcastId: null },
          }),
        );

        dispatch(onClickAutomationTile());
      }

      if (type === 'manual') {
        e.preventDefault();

        dispatch(
          pushModal({
            name: 'AudiogramDestination',
          }),
        );

        dispatch(onCreateManualAudiogram());
      }

      if (type === 'transcribe') {
        dispatch(onClickTranscribe());
      }
    },
    [dispatch],
  );

  return {
    onNewProjectClick: handleNewProjectClick,
  };
}
